const city = "abuja"

const deliveryPrices = [
  { amount: 4000, label: "Lifecamp", value: "lifecamp", city },
  { amount: 4500, label: "Lifecamp extension", value: "lifecamp", city },
  { amount: 4500, label: "Jahi", value: "jahi", city },
  { amount: 3000, label: "Utako", value: "utako", city },
  { amount: 5000, label: "Gwarimpa", value: "gwarimpa", city },
  { amount: 4500, label: "Kado", value: "kado", city },
  { amount: 3000, label: "Mabushi", value: "mabushi", city },
  { amount: 4000, label: "Central Area", value: "central", city },
  { amount: 3500, label: "Wuse", value: "wuse", city },
  { amount: 5000, label: "Durumi", value: "durumi", city },
  { amount: 4000, label: "Garki", value: "garki", city },
  { amount: 5500, label: "Gusau", value: "gusau", city },
  { amount: 6500, label: "Dutse", value: "dutse", city },
  { amount: 6500, label: "Kubwa", value: "kubwa", city },
  { amount: 6500, label: "Kagini", value: "kagini", city },
  { amount: 7000, label: "Dei-Dei", value: "dei-dei", city },
  { amount: 6500, label: "Asokoro", value: "asokoro", city },
  { amount: 5500, label: "Lokogoma", value: "lokogoma", city },
  { amount: 6500, label: "Abacha Barracks", value: "abacha", city },
  { amount: 5500, label: "Games village", value: "games", city },
  { amount: 6500, label: "Aso Villa", value: "aso", city },
  { amount: 7500, label: "Mararaba", value: "mararaba", city },
  { amount: 7500, label: "Jikwoyi", value: "jikwoyi", city },
  { amount: 8000, label: "Masaka", value: "masaka", city },
  { amount: 3500, label: "Jabi", value: "jabi", city },
  { amount: 5500, label: "Guzape", value: "guzape", city },
  { amount: 5500, label: "Dawaki", value: "dawaki", city },
  { amount: 6500, label: "Mpape", value: "mpape", city },
  { amount: 5500, label: "Apo resettlement", value: "apo", city },
  { amount: 5000, label: "Apo Legislative", value: "apo", city },
  { amount: 5000, label: "Apo village", value: "apo", city },
  { amount: 5000, label: "Karmo", value: "karmo", city },
  { amount: 5000, label: "Sunnyvale", value: "sunnyvale", city },
  { amount: 5000, label: "Gudu", value: "gudu", city },
  { amount: 5000, label: "Suncity", value: "suncity", city },
  { amount: 5500, label: "Prince & Princess", value: "prince", city },
  { amount: 7500, label: "Bwari", value: "bwari", city },
  { amount: 6500, label: "Nyanya", value: "nyanya", city },
  { amount: 6500, label: "Karu", value: "karu", city },
  { amount: 7000, label: "Karu Bingham UNI.", value: "karu", city },
  { amount: 5500, label: "Lugbe FHA Area", value: "lugbe", city },
  { amount: 8500, label: "Lugbe After Dunamis", value: "lugbe-dunamis", city },
  { amount: 10500, label: "Airport", value: "airport", city },
  { amount: 9000, label: "Kuje", value: "kuje", city },
  { amount: 9000, label: "Gwagwalada", value: "gwagwalada", city },
  { amount: 4500, label: "Maitama", value: "maitama", city },
  { amount: 6500, label: "Idu", value: "idu", city },
  { amount: 8500, label: "Kurudu", value: "kurudu", city },
  { amount: 5500, label: "Karsana", value: "karsana", city },
  { amount: 5000, label: "Citec Mbora", value: "citec", city },
  { amount: 4500, label: "Sauka", value: "sauka", city },
  { amount: 3500, label: "Wuye", value: "wuye", city },
  { amount: 5000, label: "Galadimawa", value: "galadimawa", city },
  { amount: 5000, label: "Katampe", value: "katampe", city },
  { amount: 5500, label: "AYA", value: "aya", city },
  { amount: 5000, label: "Gaduwa", value: "gaduwa", city },
  {
    amount: 17500,
    label: "Intercity / Outside Abuja",
    value: "intercity",
    city,
  },
  {
    amount: 15500,
    label: "Other",
    value: "other",
    city,
  },
]

module.exports = deliveryPrices
